
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/buying/process-of-buying",
      function () {
        return require("private-next-pages/content/buying/process-of-buying.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/buying/process-of-buying"])
      });
    }
  